import { LoadingStrip } from '../LoadingStrip/LoadingStrip';
import { Wrapper, Dot, DotWrapper } from './LoadingListItem.styles';

export const LoadingListItem = ({ className }: { className?: string }) => (
  <Wrapper className={className}>
    <DotWrapper>
      <Dot />
    </DotWrapper>
    <LoadingStrip />
  </Wrapper>
);
